import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
const ContextMenu = ({ actions, anchorPosition, open, onActionClicked, onClose, }) => {
    return (React.createElement(Fragment, null, Boolean(actions.length) && (React.createElement(Menu, { open: open, onClose: onClose, anchorReference: "anchorPosition", anchorPosition: anchorPosition, slotProps: {
            list: {
                dense: true,
                sx: { minWidth: '200px' },
            }
        } }, actions.map((action) => (React.createElement(MenuItem, { key: action.id, onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            onActionClicked(action);
        } },
        React.createElement(ListItemText, null, action.label),
        Boolean(action.hotkey) && (React.createElement(Typography, { variant: "body2", sx: { color: 'text.secondary' } }, action.hotkey)))))))));
};
const WithContextMenu = ({ actions = [], onActionInProgress = () => { }, onActionFinalized = () => { }, openedClassName, closedClassName, onOpenChanged, children, }) => {
    const [contextPosition, setContextPosition] = useState(null);
    const onContextMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setContextPosition(contextPosition ? null : { left: event.clientX, top: event.clientY });
    };
    const closeContextMenu = setContextPosition.bind(null, null);
    useEffect(() => {
        if (onOpenChanged) {
            onOpenChanged(Boolean(contextPosition));
        }
    }, [contextPosition]);
    const [actionToConfirm, setActionToConfirm] = useState(null);
    const clearActionToConfirm = setActionToConfirm.bind(null, null);
    const executeAction = (action) => {
        if (action.confirmation) {
            setActionToConfirm(action);
        }
        else if (action.async) {
            onActionInProgress({
                ...action,
                run: (input) => {
                    onActionFinalized(action);
                    action.run(input);
                },
            });
        }
        else {
            action.run();
        }
        closeContextMenu();
    };
    const menuAnchorRef = useRef(null);
    useEffect(() => {
        const handler = (e) => {
            const hotkeyedAction = actions.find((action) => action.hotkey === e.key);
            hotkeyedAction && executeAction(hotkeyedAction);
        };
        menuAnchorRef.current?.addEventListener('keydown', handler);
        return () => menuAnchorRef.current?.removeEventListener('keydown', handler);
    }, [menuAnchorRef, actions]);
    return (React.createElement("div", { ref: menuAnchorRef, className: Boolean(contextPosition) ? openedClassName : closedClassName, onContextMenu: actions.length ? onContextMenu : undefined },
        children,
        React.createElement(ContextMenu, { open: Boolean(contextPosition), actions: actions, anchorPosition: contextPosition || undefined, onActionClicked: executeAction, onClose: closeContextMenu }),
        Boolean(actionToConfirm) && (React.createElement(Dialog, { open: true, onClose: clearActionToConfirm },
            React.createElement(DialogTitle, null, actionToConfirm?.confirmation?.title),
            React.createElement(DialogActions, null,
                React.createElement(Button, { autoFocus: true, onClick: clearActionToConfirm }, "No"),
                React.createElement(Button, { onClick: () => {
                        actionToConfirm?.run();
                        clearActionToConfirm();
                    } }, "Yes"))))));
};
export default WithContextMenu;
//# sourceMappingURL=WithContextMenu.js.map